import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Col,
  Form,
  Row,
  Modal,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { Field, FormikProvider, useFormik } from "formik";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import * as Yup from "yup";
import { post } from "../../../helpers/api_helper";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";
import {
  ActiveInactive_Record,
  delete_Record,
  errorMessage,
  successMessage,
} from "../CommonFunctions";
import swal from "sweetalert";
import {
  POST_CustomerActiveInActive,
  POST_CustomerDelete,
  POST_CustomerExport,
  POST_CustomerResetPasswordUpdate,
  POST_GetCustomerList,
  POST_GetCustomerReviseList,
} from "../../../helpers/url_helper";
import { useFilter } from "../../../../context/FilterContext";

const Customer = () => {
  const [showFilter, setShowFilter] = useState(false);
  const { filter, updateFilter } = useFilter();

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "customer" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "customer" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "customer" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "customer" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [customerList, setCustomerList] = useState([]);

  const [isPasswordNew, setIsPasswordNew] = useState(true);

  const [reviseHistoryModal, setReviseHistoryModal] = useState(false);
  const [reviseHistoryCustomerName, setReviseHistoryCustomerName] =
    useState("");
  const [reviseHistoryList, setReviseHistoryList] = useState([]);

  const getReviseHistory = (customerIDEncrypt, customerName) => {
    setIsLoading(true);
    post(POST_GetCustomerReviseList, {
      CustomerIDEncrypt: customerIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setReviseHistoryList(response?.ListOfCustomerRevise ?? []);
          setReviseHistoryCustomerName(customerName);
          setReviseHistoryModal(true);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Status: filter && filter?.page == "customer" ? filter?.Status : -1,
      Search: filter && filter?.page == "customer" ? filter?.Search : "",
      // Search: "",
      // Status: -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { Search, Status },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      Status: -1,
      Search: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "customer",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Status: Status,
      Search: Search ? Search : "",
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CompanyName: AuthUser?.CompanyName,
    };

    await post(POST_GetCustomerList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setCustomerList(response?.CustomerList);
        setIsLoading(false);

        if (page > 1 && response?.CustomerList?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const exportReport = () => {
    setIsLoading(true);

    let payload = {
      Search: Search,
      Status: Status,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    };
    post(POST_CustomerExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          //swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [customerResetPasswordModal, setCustomerResetPasswordModal] =
    useState(false);

  const CustomerResetPassword = (CustID, CustName, Lolink) => {
    formikCustomerResetPassword.resetForm();
    setCustomerResetPasswordModal(true);
    formikCustomerResetPassword.setFieldValue("CustomerIDEncrypt", CustID);
    formikCustomerResetPassword.setFieldValue("CustomerName", CustName);
    formikCustomerResetPassword.setFieldValue("LoginLink", Lolink);
  };

  const validationSchemaCustomerResetPassword = Yup.object().shape({
    NewPassword: Yup.string()
      .required("New Password is required field")
      .matches(
        /^(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain Minimum 8 Characters, One Capital Letter and One Special Character"
      ),
    //NewPassword: Yup.string().required("New Password is required field"),
    ConfirmPassword: Yup.string()
      .oneOf([Yup.ref("NewPassword"), null], "Passwords must match")
      .required("Confirm Password is a required field."),
  });

  const formikCustomerResetPassword = useFormik({
    validationSchema: validationSchemaCustomerResetPassword,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitCustomerResetPassword(values, formikHelpers),
    initialValues: {
      CustomerIDEncrypt: "",
      NewPassword: "",
      ConfirmPassword: "",
      CustomerName: "",
      LoginLink: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { NewPassword, ConfirmPassword },
  } = formikCustomerResetPassword;

  const handleValidSubmitCustomerResetPassword = (values) => {
    swal({
      title: "Are you sure you want to Reset Password the record?",
      text: "You won't be able to revert this!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      //buttons: ["No", "Yes"],
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "btn-sm",
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "btn-sm",
          closeModal: true,
        },
      },
    }).then((willResetPassword) => {
      if (willResetPassword) {
        setIsLoading(true);
        let payload = {
          ...values,
          CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
          BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
          ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
            ? AuthUser?.ReferenceIDEncrypt
            : "0",
        };

        post(POST_CustomerResetPasswordUpdate, payload)
          .then((response) => {
            if (response?.IsSuccess) {
              successMessage(response?.Message);
              setTimeout(() => {
                formikCustomerResetPassword.resetForm();
                setCustomerResetPasswordModal(false);
                getData();
              }, 1000);
            } else {
              errorMessage(response?.Message);
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Customer</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore" aria-hidden="true"></i>
                    {"  "}
                    Reset
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                      //  setShowFilter(false);
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 10 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      // className="btn btn-primary light btn-sm me-2"
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportReport}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Report
                    </Link>
                  ) : (
                    ""
                  )}
                  {/* <Link to="/add-customer" className="btn btn-primary btn-sm">
                    + Add Customer
                  </Link>
                   */}
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 10 && x?.IsAdd)
                    ?.length > 0 ? (
                    <Link
                      to={`/add-customer/${false}`}
                      // className="btn btn-primary btn-sm"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add Customer
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Search"
                              name="Search"
                              placeholder={"Search here..."}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Status"
                              name="Status"
                              placeholder={"Select Status"}
                              options={statusOptions}
                              component={CustomSelect}
                              isClearable={false}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  // className="btn btn-primary btn-sm mb-1"
                                  className="btn btn-primary btn-sm"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="Customer-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="projects-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="6%"></th>
                        <th
                          style={{
                            width: "26%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Customer Name{" "}
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("GSTRegistrationTypeName");
                          }}
                        >
                          GST Registration Type{" "}
                          <span className="ml-1">
                            {sortBy == "GSTRegistrationTypeName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "20%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("EmailID");
                          }}
                        >
                          Email{" "}
                          <span className="ml-1">
                            {sortBy == "EmailID" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "27%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ProjectNames");
                          }}
                        >
                          Project Name{" "}
                          <span className="ml-1">
                            {sortBy == "ProjectNames" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "6%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("IsTPI");
                          }}
                        >
                          TPI{" "}
                          <span className="ml-1">
                            {sortBy == "IsTPI" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {customerList?.length > 0 ? (
                        customerList?.map((item, indx) => (
                          <tr key={indx}>
                            <td>
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 10 && x?.IsEdit
                              )?.length > 0 ? (
                                <Link
                                  to={`/edit-customer/${false}/${window.btoa(
                                    item.CustomerIDEncrypt
                                  )}`}
                                  // className="icon-box icon-box-md bg-primary-light me-1"
                                  className="icon-box icon-box-md me-1"
                                  title="Edit"
                                >
                                  {SVGICON.EditPrimary}
                                </Link>
                              ) : (
                                ""
                              )}
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 10 && x?.IsActive
                              )?.length > 0 ? (
                                <Link
                                  to="#"
                                  // className={`icon-box icon-box-md bg-${
                                  //   item.IsActive === true ? "success" : "danger"
                                  // }-light me-1`}
                                  className={`icon-box icon-box-md me-1`}
                                  title={
                                    item.IsActive === true
                                      ? "Active"
                                      : "Inactive"
                                  }
                                  onClick={() => {
                                    ActiveInactive_Record(
                                      item.IsActive,
                                      POST_CustomerActiveInActive,
                                      {
                                        CustomerIDEncrypt:
                                          item.CustomerIDEncrypt,
                                        IsActive: !item.IsActive,
                                        ModifiedByEncrypted:
                                          AuthUser?.ReferenceIDEncrypt
                                            ? AuthUser?.ReferenceIDEncrypt
                                            : "0",
                                      },
                                      setIsLoading,
                                      fnCallback,
                                      item.CustomerName
                                    );
                                  }}
                                >
                                  <i
                                    className={`fa fa-circle fs-15 ${
                                      item.IsActive === true
                                        ? "text-success"
                                        : "text-danger"
                                    }`}
                                  ></i>
                                </Link>
                              ) : (
                                ""
                              )}
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 10 && x?.IsEdit
                              )?.length > 0 ? (
                                <Link
                                  to={`/revise-customer/${window.btoa(
                                    item.CustomerIDEncrypt
                                  )}`}
                                  className="icon-box icon-box-md me-1"
                                  title="Revise"
                                >
                                  <i className="fa fa-refresh"></i>
                                </Link>
                              ) : (
                                ""
                              )}
                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="Revise History"
                                onClick={() => {
                                  getReviseHistory(
                                    item.CustomerIDEncrypt,
                                    item.CustomerName
                                  );
                                }}
                              >
                                <i className="fa fa-history"></i>
                              </Link>
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 10 && x?.IsDelete
                              )?.length > 0 ? (
                                <Link
                                  to="#"
                                  // className="icon-box icon-box-md bg-danger-light"
                                  className="icon-box icon-box-md me-1"
                                  title="Delete"
                                  onClick={() => {
                                    delete_Record(
                                      POST_CustomerDelete,
                                      {
                                        CustomerIDEncrypt:
                                          item.CustomerIDEncrypt,
                                        ModifiedByEncrypted:
                                          AuthUser?.ReferenceIDEncrypt
                                            ? AuthUser?.ReferenceIDEncrypt
                                            : "0",
                                      },
                                      setIsLoading,
                                      fnCallback,
                                      item.CustomerName
                                    );
                                  }}
                                >
                                  {SVGICON.DeleteDanger}
                                </Link>
                              ) : (
                                ""
                              )}
                              {AuthUser?.Permissions?.CustomerLogin == 1 &&
                              item?.LoginFlag == 1 ? (
                                <Link
                                  to="#"
                                  className={`icon-box icon-box-md me-1`}
                                  title="Reset Password"
                                  onClick={() => {
                                    CustomerResetPassword(
                                      item?.CustomerIDEncrypt,
                                      item?.CustomerName,
                                      item?.LoginLink
                                    );
                                  }}
                                >
                                  {SVGICON.ResetLock}
                                </Link>
                              ) : (
                                ""
                              )}
                            </td>
                            <td>{item.CustomerName}</td>
                            <td>{item.GSTRegistrationTypeName}</td>
                            <td>{item.EmailID}</td>
                            {/* <td
                              className="popupOverlay"
                              style={{ textAlign: "left", cursor: "pointer" }}
                              trigger="click"
                              key={indx}
                              responsive={true}
                              overlay={
                                <Tooltip
                                  className="toltip-popover"
                                  id={`popover-positioned-${item.ProjectNames.toLowerCase()}`}
                                >
                                  <strong>{item.ProjectNames}</strong>
                                </Tooltip>
                              }
                            >
                              {item.ProjectNames}
                            </td> */}
                            <td
                              style={{ cursor: "pointer" }}
                              className="popupOverlay"
                            >
                              <OverlayTrigger
                                trigger={["hover", "focus"]}
                                key={indx}
                                responsive={true}
                                overlay={
                                  <Tooltip
                                    className="toltip-popover"
                                    // id={`popover-positioned-${item.ProjectNames.toLowerCase()}`}
                                  >
                                    <strong className="p-1">
                                      {item.ProjectNames}
                                    </strong>
                                  </Tooltip>
                                }
                              >
                                <span>{item.ProjectNames}</span>
                              </OverlayTrigger>
                            </td>
                            <td style={{ textAlign: "left" }}>
                              {item.IsTPI ? "Yes" : "No"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={7} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={customerResetPasswordModal}
            onHide={setCustomerResetPasswordModal}
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikCustomerResetPassword}>
                <Form onSubmit={formikCustomerResetPassword.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>Reset Password</Modal.Title>
                    <button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setCustomerResetPasswordModal(false)}
                    ></button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col lg={12}>
                        <Field
                          label="Customer Name"
                          name="CustomerName"
                          placeholder={"Enter Customer Name"}
                          component={CustomInput}
                          disabled={true}
                        />
                      </Col>
                      <Col lg={12}>
                        <Field
                          label="Login Link"
                          name="LoginLink"
                          placeholder={"Login Link"}
                          component={CustomInput}
                          disabled={true}
                        />
                      </Col>
                      <Col lg={12}>
                        <Field
                          type={isPasswordNew ? "password" : "text"}
                          label="New Password"
                          name="NewPassword"
                          placeholder={"Enter New Password"}
                          component={CustomInput}
                          passwordEye={true}
                          setIsPassword={setIsPasswordNew}
                          required
                        />
                      </Col>

                      <Col lg={12}>
                        <Field
                          type="password"
                          label="Confirm Password"
                          name="ConfirmPassword"
                          placeholder={"Enter Confirm Password"}
                          component={CustomInput}
                          required
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      className="btn btn-primary btn-sm me-2"
                      type="submit"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Reset Password
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => setCustomerResetPasswordModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
          <Modal
            className="fade"
            show={reviseHistoryModal}
            onHide={setReviseHistoryModal}
            size="xl"
          >
            <Modal.Header>
              <Modal.Title>Revise History - {reviseHistoryCustomerName}</Modal.Title>
              <button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setReviseHistoryModal(false)}
              ></button>
            </Modal.Header>
            <Modal.Body>
              <div className="table-responsive">
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th>Version</th>
                      <th>Customer Name</th>
                      <th>Short Name</th>
                      <th>Email</th>
                      <th>GST No</th>
                      <th>Project Name</th>
                      <th>Effective Date</th>
                      <th>Created On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reviseHistoryList?.length > 0 ? (
                      reviseHistoryList.map((row, idx) => (
                        <tr key={idx}>
                          <td>
                            {row.ReviseType == 1 ? (
                              <span className="badge badge-sm badge-success">
                                Current
                              </span>
                            ) : (
                              <span className="badge badge-sm badge-secondary">
                                Old
                              </span>
                            )}
                          </td>
                          <td>{row.CustomerName}</td>
                          <td>{row.ShortName}</td>
                          <td>{row.EmailID}</td>
                          <td>{row.GSTNo}</td>
                          <td>{row.ProjectNames}</td>
                          <td>{row.EffectiveDate}</td>
                          <td>{row.CreatedDate}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} className="text-center">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-danger btn-sm"
                onClick={() => setReviseHistoryModal(false)}
              >
                <i className="fa fa-cancel"></i> Close
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Customer;
